import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const path = '/item-creation-wizard';

export const getWeatherZones = createAsyncThunk('getWeatherZones', async () => {
    const response = await axios.get(`${path}/weatherZones`);

    return response.data;
});
